export default{
  goodsDetails:{
    breadcrumb:{
      home:"Home",
      all:"All Products"
    },
    BaseInfo:{
      label:{
        outputUnit:"Daily Supply",
        outputUnit1:"Supply",
        price:"Price",
        depositPercent:"Deposit",
        serviceList:"Services",
        reight:"Shipping Fee",
        count:"Purchase Quantity",
        orderPay:"Place an order and pay",
        origin:'Origin',
        ExpCountry:'ountry of Origin',
        supplyCycleType:"supply Cycle ",
      },
      value:{
        egotiable:"Negotiable",
        serviceList:["Vehicle Sourcing","Buyer Pickup","Logistics Delivery"],
        reight:"Negotiable",
        canBuy:"Available:",
        money:"¥",
        noStock:"No inventory"
      },
      tips:{
        delist:"This product has been delisted",
      }
    },
    TradeFlow:{
      title:"Transaction Process",
      steps:["Select Product","Place Order","Make Payment","Pay Deposit","Pay Balance","Seller Ships/Releases","Confirm Receipt/Pickup","Transaction Completed"],
      tips:{
        title:"Note:",
        items:["1. For invoices, apply at 'Account Center - Invoice Management' after transaction.","2. To ensure delivery timeliness, please pay the balance as agreed."]
      }
    },
    Button:{
      goBuy:"Buy Now",
      car:"Add to Cart",
      collect:"Favorite",
      collected:"Favorite",
      sampleGobuy:"Order Sample",
      customer:"Contact Support",
      collectShopDel:"Unfollow Store",
      collectShop:"Follow Store",
      goToShop:"Visit Store",
      soldOut:"Sold out",
      sampleAppletUrl:"Dropshipping"
    },
    DetailsInfo:{
      title:"Product Details",
      categoryName:"Category",
      brand:"Brand",
      spuNum:"Product ID",
      shopName:"Business Name",
      productName:"Product Name"
    },
    shopInfo:{
      conter:"Contact:",
      tel:"Phone:"
    },
    HotSale:{
      title:"Store Best Sellers",
      money:"¥",
      saleCount:"Sold",
      saleCountunit:"units",
      egotiable:"Negotiable",
    },
    Confirm:{
      title:"Notification",
      content:"Item added to cart",
      confirmButtonText:"Checkout",
      cancelButtonText:"Continue Shopping"
    },
    Message:{
      hasSpecarrNoselect:"Please select specifications",
      collectSuc:"Added to favorites",
      collectDel:"Removed from favorites",
      shopCollect:"Store followed",
      shopCollectDel:"Store unfollowed",
    },
    baseDetails:{
      baseName:"Manufacturing Site Name",
      baseCertification:"Manufacturing Site Certification",
      output:"Annual Production",
      unit:"kg",
      click:"Click to view",
    },
    TabsName:{
      tab1:"Product Details",
      tab2:"Base Information",
      tab3:"Product Cerftification",
      tab4:"Test Report",
      tab5:"Quality Assessment",
      tab6:"Transaction Specifications",
      tab21:"Designated Demonstration Bases"
    }
  }
}